export default __webpack_public_path__ + "static/Teodor-Light-009b219f945c9ad5e78b7ebd4558f844.woff";